import React from 'react';
import { CompareCardsCheckbox } from 'partial/OfferManager/OfferCarouselContainer';
import { SeeAllCards } from 'components/Offers/SeeAllCards/SeeAllCards';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Row } from 'components/Containers/Row/Row';
import OfferCarouselContainer from 'partial/OfferManager/OfferCarouselContainer';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import './UnifiedCCOffersContainer.scss';
import StandardRedesignMarketplaceCreditCardOfferSwitch from 'components/Offers/StandardRedesignMarketplaceCreditCardOfferSwitch/StandardRedesignMarketplaceCreditCardOfferSwitch';

const UnifiedCCOffersContainer = props => {
  const {
    datatestid,
    atr,
    cardComparisonAttributes,
    eventHandler,
    containerType,
    modulePosition,
    offers,
    onLinkClickCallback,
    optimizelyExperimentObj,
    partnersCustomTrackingMeta,
    pagePosition,
    seeAllLink,
    seeAllText,
    seeAllKey,
    isOffersPage,
    isOcfPage,
    isHighlightFirstCard,
    extraAttributes,
    moduleHeading,
    redirectClickApplyToClickDetails,
    mobileMarginOverride,
  } = props;
  return (
    <>
      <FlexContainer className={'flex-column m-hide CcOfferTrayContainer'}>
        <Row className="carousel">
          <OfferCarouselContainer
            offers={offers}
            type={'creditCardRedesignCarousel'}
            containerType={containerType}
            pagePosition={pagePosition}
            eventHandler={eventHandler}
            datatestid={`${datatestid}`}
            modulePosition={modulePosition}
            partnersCustomTrackingMeta={partnersCustomTrackingMeta}
            optimizelyExperimentObj={optimizelyExperimentObj}
            creditCardTemplate={
              StandardRedesignMarketplaceCreditCardOfferSwitch
            }
            templateCustomClass={'margt6'}
            seeAllCards={
              <SeeAllCards
                link={seeAllLink}
                location={'offers-creditcards'}
                datatestid={`${datatestid}-seeall`}
                onLinkClickCallback={onLinkClickCallback}
                module={pagePosition}
                extraEventAttributes={atr}
                description={seeAllText}
                key={seeAllKey}
              />
            }
            showSeeMoreCardsLink={props.showSeeMoreCardsLink}
            //exp POD3-2522
            cardsSelected={cardComparisonAttributes?.cardsSelected || []}
            customTopper={
              cardComparisonAttributes?.showCheckbox ? CompareCardsCheckbox : ''
            }
            showCheckbox={cardComparisonAttributes?.showCheckbox}
            handleCheckboxClick={cardComparisonAttributes?.handleCheckboxClick}
            isOffersPage={isOffersPage}
            isHighlightFirstCard={isHighlightFirstCard}
            isOcfPage={isOcfPage}
            extraAttributes={extraAttributes}
            moduleHeading={moduleHeading}
          />
        </Row>
      </FlexContainer>
      <FlexContainer
        className={`d-hide flex-column ${mobileMarginOverride || 'marglr12'}`}
      >
        <StaticOfferContainer
          isHighlightFirstCard={isHighlightFirstCard}
          offerMetadataList={isOcfPage ? offers : offers?.slice(0, 5)}
          containerType={containerType}
          pagePosition={pagePosition}
          creditCardTemplate={StandardRedesignMarketplaceCreditCardOfferSwitch}
          eventHandler={eventHandler}
          modulePosition={modulePosition}
          datatestid={`${datatestid}`}
          optimizelyExperimentObj={optimizelyExperimentObj}
          extraAttributes={extraAttributes}
          moduleHeading={moduleHeading}
          redirectClickApplyToClickDetails={redirectClickApplyToClickDetails}
          partnersCustomTrackingMeta={partnersCustomTrackingMeta}
        />
      </FlexContainer>
    </>
  );
};

export default UnifiedCCOffersContainer;
